import { Link } from "react-router-dom";
import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { House, EnvelopeSimple } from "@phosphor-icons/react";

export function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email: email.trim() });
      toast.success(data.message || "You're subscribed. Thanks!");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#2C2B29] text-[#EADDC8] mt-20 max-md:pb-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-[#D17A58] text-white">
              <House size={18} weight="duotone" />
            </span>
            <span className="font-display text-2xl font-semibold text-white">HomeHearth</span>
          </div>
          <p className="text-sm text-[#EADDC8]/70 max-w-md leading-relaxed">
            Thoughtfully curated home and kitchen essentials — vetted, reviewed,
            and worth your counter space. We earn a small commission on qualifying
            purchases at no cost to you.
          </p>
        </div>
        <div>
          <h4 className="font-display text-lg text-white mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link data-testid="footer-lists" to="/lists" className="hover:text-white">Curated Lists</Link></li>
            <li><Link data-testid="footer-blog" to="/blog" className="hover:text-white">Blog</Link></li>
            <li><Link data-testid="footer-category-kitchen" to="/category/Kitchen%20Appliances" className="hover:text-white">Kitchen Appliances</Link></li>
            <li><Link data-testid="footer-category-cookware" to="/category/Cookware" className="hover:text-white">Cookware</Link></li>
            <li><Link data-testid="footer-category-decor" to="/category/Home%20Decor" className="hover:text-white">Home Decor</Link></li>
            <li><Link data-testid="footer-disclosure" to="/disclosure" className="hover:text-white">Disclosure</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display text-lg text-white mb-4">Deal alerts</h4>
          <p className="text-sm text-[#EADDC8]/70 mb-4">Weekly picks. No spam.</p>
          <form onSubmit={subscribe} className="flex gap-2">
            <div className="relative flex-1">
              <EnvelopeSimple size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5C5A56]" />
              <input
                data-testid="newsletter-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="w-full pl-9 pr-3 py-2 rounded-full text-sm bg-white text-[#2C2B29] focus:outline-none"
              />
            </div>
            <button
              data-testid="newsletter-submit"
              type="submit"
              disabled={loading}
              className="hh-btn-primary rounded-full px-4 py-2 text-sm font-medium disabled:opacity-60"
            >
              {loading ? "..." : "Join"}
            </button>
          </form>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-[#EADDC8]/60">
          <p>© {new Date().getFullYear()} HomeHearth. Independently owned.</p>
          <p>As an Amazon Associate we earn from qualifying purchases.</p>
        </div>
      </div>
    </footer>
  );
}
